module.exports = __webpack_public_path__ + "static/media/settings.d6825a6b.svg";